<template>
    <div>
        <div class="mobile-nav-bar">
            <div class="row">
                <div class="col-6 col-sm-6">
                    <div class="mobile-logo">
                        <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png" alt="Rubies Logo">
                    </div>
                </div>
                <div class="col-6 col-sm-6">
                    <div class="">
                        <button v-bind:class="{ 'is-active': getMenuIsActive }" class="hamburger hamburger--collapse" type="button" @click="handleClick()">
                              <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                              </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "SidebarToggle",
        data () {
            return {
                isActive: false
            }
        },
        computed: {
            ...mapGetters([
                'getMenuIsActive',
            ]),

            open () {
                return this.$store.state.sidebarOpen
            }
        },
        methods: {
            ...mapActions([
                'updateMenuIsActive',
            ]),


            handleClick () {
                this.$store.dispatch('toggleSidebar')
                this.updateMenuIsActive (!this.getMenuIsActive)
            }
        }
    }
</script>

<style scoped>
    .hamburger-box {
        width: 35px;
        height: 24px;
    }


</style>